<script lang="ts">
  import Form from "../components/Form.svelte";
  import RadioGroup from "../components/RadioGroup.svelte";
  import SharepointFileInput from "../components/SharepointFileInput.svelte";
  import { domId } from "../lib/dom";

  let {
    action,
    taskTitle,
    reason,
    createUploadSessionUrl,
    uploadAttachmentExtensions,
    errors,
  }: {
    action: string;
    taskTitle: string;
    reason: string;
    createUploadSessionUrl: string;
    uploadAttachmentExtensions: {
      driving_licence: string[];
      passport: string[];
      proof_of_address: string[];
    };
    errors: { [key: string]: string } | null;
  } = $props();

  let selectedOption: string = $state("driving_licence");
  const closeDialogId = domId("close-dialog");
</script>

<Form method="patch" {action} class="ui-rhythm">
  <h2 class="ui-title">{taskTitle}</h2>

  <p>{reason}</p>

  <fieldset class="ui-fieldset">
    <legend>Which document(s) would you like to upload?</legend>
    <RadioGroup
      name="identification_type"
      options={[
        ["Driving licence", "driving_licence"],
        ["Passport and proof of address", "passport_address"],
      ]}
      bind:group={selectedOption}
      required
    />
  </fieldset>

  <fieldset class="ui-fieldset mt-6" disabled={selectedOption !== "driving_licence"}>
    <legend>Upload your driving licence</legend>

    <div>
      <p class="ui-alert ui-alert-info pb-4 -mb-2.5 mt-0">Please provide a clear photo of the front of your driving licence.</p>
      <SharepointFileInput
        name="driving_licence"
        accept={uploadAttachmentExtensions.driving_licence}
        {createUploadSessionUrl}
        required
      />
    </div>

    {#if errors?.driving_licence}<div class="ui-error">{errors.driving_licence}</div>{/if}
  </fieldset>

  <fieldset class="mt-6" disabled={selectedOption !== "passport_address"}>
    <fieldset class="ui-fieldset">
      <legend>Upload your passport</legend>

      <div>
        <p class="ui-alert ui-alert-info pb-4 -mb-2.5 mt-0">Please provide a clear photo of the personal details page.</p>
        <SharepointFileInput
          name="passport"
          accept={uploadAttachmentExtensions.passport}
          {createUploadSessionUrl}
          required
        />
      </div>

      {#if errors?.passport}<div class="ui-error">{errors.passport}</div>{/if}
    </fieldset>

    <fieldset class="ui-fieldset">
      <legend>Upload a proof of your current address</legend>

      <div>
        <p class="ui-alert ui-alert-info pb-4 -mb-2.5 mt-0">
          <span>Valid documents include utility bills, bank statements, tenancy agreements, title register, etc. <b>Must be dated within 90 days.</b></span>
        </p>
        <SharepointFileInput
          name="proof_of_address"
          accept={uploadAttachmentExtensions.proof_of_address}
          {createUploadSessionUrl}
          multiple
          required
        />
      </div>

      {#if errors?.proof_of_address}<div class="ui-error">{errors.proof_of_address}</div>{/if}
    </fieldset>
  </fieldset>

  {#if errors?.general}<div class="ui-error">{errors.general}</div>{/if}

  <div class="floating-footer">
    <button class="btn btn-ghost" form={closeDialogId}>Cancel</button>
    <button class="btn btn-primary" type="submit" data-viewer-mode>Send</button>
  </div>
</Form>

<form method="dialog" id={closeDialogId}></form>

<style>
  fieldset[disabled] {
    display: none;
  }
</style>
